export const COMPONENT_STATE_INITIALIZE = 0;
export const COMPONENT_STATE_RENDERED = 1;
export const COMPONENT_STATE_WILLDESTROY = 2;
export const COMPONENT_STATE_DESTROIED = 3;
export type ComponentState = 0 | 1 | 2 | 3;

export const CONTEXT_STATE_UNTOUCH = 0;
export const CONTEXT_STATE_TOUCHED = 1;
export const CONTEXT_STATE_UNTOUCH_FREEZED = 2;
export const CONTEXT_STATE_TOUCHED_FREEZED = 3;
export type ContextState = 0 | 1 | 2 | 3;

export type Context = Record<string | number | symbol, unknown>;

export const DEFAULT_SLOT_NAME = 'slot:default';
export const __ = Symbol();
export const ROOT_NODES = Symbol();
export const NON_ROOT_COMPONENT_NODES = Symbol();
export const REFS = Symbol();
export const CONTEXT = Symbol();
export const ONMOUNT = Symbol();
export const UNMOUNT_FNS = Symbol();
export const STATE = Symbol();
export const CONTEXT_STATE = Symbol();
